<template>
  <div class="spinner-overlay" v-if="show">
    <div class="spinner-content" role="alert" aria-live="assertive">
      <div class="spinner-ring" aria-hidden="true"></div>
      <p v-if="message" class="loading-message">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  max-width: 90%;
  text-align: center;
}

.spinner-ring {
  width: 60px;
  height: 60px;
  border: 8px solid #f3f3f3;
  border-top: 8px solid var(--hollywood-cerise);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-message {
  font-size: 1rem;
  color: var(--violet-lush);
  font-weight: 500;
  line-height: 1.4;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
